<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row">
      <form
        class="needs-validation"
        [formGroup]="paypalform"
        (ngSubmit)="onSubmit()"
      >
        <div class="row d-flex justify-content-between align-items-center mb-4">
          <div class="col-10 d-flex align-items-center">
            <h4 class="card-title m-0 offcanvas-header-text d-flex align-items-center">
              PayPal Settings
              <!-- <i
                class="mdi mdi-information-outline font-size-16 ms-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="You can show or hide the foooter's component at the bottom of your Channel Posts"
              ></i> -->
            </h4>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 mb-3">
            <label
              for="environment"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Environment
            </label>
            <select
              class="form-select offcanvas-primary offcanvas-border-primary"
              id="environment"
              formControlName="env"
            >
              <option value="SANDBOX">Sandbox</option>
              <option value="PRODUCTION">Production</option>
            </select>
          </div>
          <div class="col-12 mb-3">
            <label
              for="merchantID"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Client ID
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="merchantID"
                formControlName="client_id"
                [ngClass]="{
                  'is-invalid': submitted && f.client_id.errors
                }"
                placeholder="Enter Client ID"
              />
              <div
                *ngIf="submitted && f.client_id.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.client_id.errors.required">
                  {{ "GENERALS.DESCRIPTIONREQUIRED" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <label
              for="merchantAccountID"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Secret Key
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="merchantAccountID"
                formControlName="client_secret"
                [ngClass]="{
                  'is-invalid': submitted && f.client_secret.errors
                }"
                placeholder="Enter Secret Key"
              />
              <div
                *ngIf="submitted && f.client_secret.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.client_secret.errors.required">
                  {{ "GENERALS.DESCRIPTIONREQUIRED" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-success w-md ms-auto">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
